(function () {
  function formatMoney(value, currencySymbol) {
    const amount = Number(value || 0) / 100;
    return currencySymbol + ' ' + amount.toFixed(2).replace(/\.00$/, '');
  }

  function initPremiumAtc() {
    document.querySelectorAll('[id^="PremiumAtcData-"]').forEach(function (dataNode) {
      if (dataNode.dataset.bound === 'true') return;
      dataNode.dataset.bound = 'true';

      let data;
      try {
        data = JSON.parse(dataNode.textContent);
      } catch (e) {
        return;
      }

      const sectionId = data.sectionId;
      const form = document.getElementById('product-form-' + sectionId);
      const button = document.getElementById('ProductSubmitButton-' + sectionId);

      if (!form || !button) return;

      const idInput = form.querySelector('.product-variant-id');
      const label = button.querySelector('[data-premium-atc-label]');
      const price = button.querySelector('[data-premium-atc-price]');
      const compare = button.querySelector('[data-premium-atc-compare]');
      const save = button.querySelector('[data-premium-atc-save]');
      const reassurance = form.closest('.product-form')?.querySelector('[data-premium-atc-reassurance-row]');

      function getVariant() {
        if (!idInput) return null;
        const id = String(idInput.value || '');
        return (data.variants || []).find(function (variant) {
          return String(variant.id) === id;
        }) || null;
      }

      function updateButtonUi() {
        const variant = getVariant();
        if (!variant) {
          if (label) label.textContent = data.labels.unavailable;
          button.disabled = true;
          return;
        }

        const isSoldOut = !variant.available;

        if (label) {
          label.textContent = isSoldOut ? data.labels.soldOut : data.labels.add;
        }

        button.disabled = isSoldOut;

        if (price && data.showPrice) {
          price.textContent = formatMoney(variant.price, data.currencySymbol);
        }

        if (compare) {
          if (data.showCompare && variant.compare_at_price > variant.price && !isSoldOut) {
            compare.textContent = formatMoney(variant.compare_at_price, data.currencySymbol);
            compare.classList.remove('hidden');
          } else {
            compare.textContent = '';
            compare.classList.add('hidden');
          }
        }

        if (save) {
          const hasDiscount = variant.compare_at_price > variant.price;
          if (data.showSave && hasDiscount && !isSoldOut) {
            const savePercent = Math.round(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price);
            save.textContent = data.savePrefix + ' ' + savePercent + '%';
            save.classList.remove('hidden');
          } else {
            save.textContent = '';
            save.classList.add('hidden');
          }
        }

        if (reassurance) {
          reassurance.style.display = isSoldOut ? 'none' : '';
        }
      }

      updateButtonUi();

      form.addEventListener('change', function () {
        setTimeout(updateButtonUi, 50);
      });

      form.addEventListener('submit', function () {
        if (label && !button.disabled) {
          label.textContent = data.labels.loading;
        }
      });

      button.addEventListener('click', function () {
        if (button.disabled) return;

        setTimeout(function () {
          if (!button.disabled && label) {
            label.textContent = data.labels.added;

            setTimeout(function () {
              updateButtonUi();
            }, 1000);
          }
        }, 250);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', initPremiumAtc);
  document.addEventListener('shopify:section:load', initPremiumAtc);
})();